import React, { useEffect, useState } from "react";
import styles from "./PlayMode.module.scss";
import { GameModal } from "../../components/shared";
import { useSelector, useDispatch } from "react-redux";
import Canvas from "../Canvas";
import { isWonSelector } from "../../store/selectors";
import { setGameGraph } from "../../store/actions";
import { Graph } from "../../models";
import { PlayModeButtons, WinModal } from "../../components/views";

const PlayMode: React.FC = () => {
  const [isModalOpen, setOpenModal] = useState<boolean>(true);
  const [isWinOpen, setWinModal] = useState<boolean>(false);

  const isWon = useSelector(isWonSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setGameGraph(new Graph()));
  }, []);

  return (
    <div className={styles.playMode}>
      {isModalOpen ? (
        <GameModal isOpen={isModalOpen} setOpen={setOpenModal} />
      ) : (
        <div className={styles.playMode__container}>
          <div className={styles.playMode__container__help}>
            <PlayModeButtons />
          </div>
          {isWon && <WinModal isOpen={isWinOpen} setOpen={setWinModal} />}

          <Canvas isExpanded={true} />
        </div>
      )}
    </div>
  );
};

export default PlayMode;
